import { cloudProviderStatus } from "./DiagnosticsCloudProviderStatus";
import type { CodexRuntimeReadiness } from "./codexRuntimeReadiness";
import { DiagnosticsSection, StatusPill } from "./DiagnosticsPanelPrimitives";

export function DiagnosticsCodexReadiness({
  readiness,
}: {
  readonly readiness: CodexRuntimeReadiness;
}) {
  const status = cloudProviderStatus({
    codexReadiness: readiness,
    sessionAuthState: "unknown",
  });

  return (
    <DiagnosticsSection
      title="Codex delivery"
      id="diagnostics-codex"
      description="Latest result from the explicit owner Recheck for this selected Environment."
      action={<StatusPill label={status.state} tone={status.tone} />}
    >
      <p className="px-3 text-sm text-muted-foreground sm:px-4">{status.evidence}</p>
    </DiagnosticsSection>
  );
}
